import React, { Component } from 'react';
import Froala from "froala-editor";
import ReactDOM from 'react-dom';
import 'froala-editor/js/froala_editor.pkgd.min';
import 'froala-editor/js/plugins.pkgd.min';
import 'froala-editor/js/languages/pt_br';
import 'froala-editor/css/froala_style.min.css';
import 'froala-editor/css/froala_editor.pkgd.min.css';
import '../assets/libs/font-awesome/css/font-awesome.css';
import Button from 'react-bootstrap/Button';
import SweetAlert from 'react-bootstrap-sweetalert/lib/dist/SweetAlert';
import intl from 'react-intl-universal';
//import '../assets/scss/froala-custom.scss';
import FroalaEditor from 'react-froala-wysiwyg';
import Axios from 'axios';
import fLoading from '../assets/img/preloader-black.gif';
import fGpt from '../assets/img/chatGpt.png';
//import url from '../config/Url';
import EncodedLocalStorage from '../config/EncodedLocalStorage';
import { Alert } from '../components/Alert';
import zIndex from '@material-ui/core/styles/zIndex';
import url from '../config/Url';

export default class FroalaEditorComponent extends Component {
  constructor(oProps) {
    super(oProps);
    this.state = {
      model: oProps.model,
      alertMessage: '',
      isLoading: false,
      bHasGptKey: localStorage.getItem('cApiGpt') === '1',
      cErrorModalMsg: '',
    };

    // Proteção contra race conditions - inicia como true para permitir primeira renderização
    this.bIsMounted = true;
    this.editorRef = null;
    
    this.hideAlert = this.hideAlert.bind(this);
    this.config = { ...oProps.config };
  }

  saveApiKey = (cNewApiKey) => {
    this.setState({ alertMessage: '' });
  }

  componentDidMount() {
    const oLocalStorage = new EncodedLocalStorage();
    const cLanguage = oLocalStorage.get('cLanguage') ? oLocalStorage.get('cLanguage') : 'pt';
    
    let pt = Froala.LANGUAGE.pt_br.translation;
    pt['Type something'] = intl.get('DocumentEditor.type_something');
    pt['Image'] = intl.get('imagem');
    pt['Insert Image'] = intl.get('DocumentEditor.insert_image');
    
    // Adiciona listeners de forma segura
    this.addEventListeners();

    Froala.DefineIconTemplate('copilot_gpt', '<img src=[SRC] alt=[ALT] style="width: 90px;height: 28px;margin-top: auto;margin-bottom: auto;border-radius: 5px;"/>');
    Froala.DefineIcon('imageIcon', { SRC: fGpt, ALT: 'Copilot GPT', template: 'copilot_gpt' });
    Froala.RegisterCommand("chatGPT", {
      title: "Copilot GPT",
      icon: 'imageIcon',
      undo: false,
      focus: false,
      plugin: 'save',
      callback: () => {
        if (!this.bIsMounted) return;
        
        const cSelection = this.getSelectedText();
        if (cSelection) {
          const bHasGptKey = localStorage.getItem('cApiGpt') === '1';
          if (bHasGptKey) {
            this.callGptAPI(cSelection);
          } else {
            this.setState({
              alertMessage: intl.get('ChatGpt.configurar_api')
            });
          }
        } else {
          this.setState({
            alertMessage: intl.get('ChatGpt.selecionar_texto')
          });
        }
      }
    });
  }

  addEventListeners = () => {
    try {
      if (typeof window !== 'undefined' && window.addEventListener) {
        window.addEventListener('scroll', this.recalculateFroalaPosition);
        window.addEventListener('resize', this.recalculateFroalaPosition);
      }
    } catch (error) {
      console.warn('Erro ao adicionar event listeners:', error);
    }
  }

  recalculateFroalaPosition = () => {
    if (!this.bIsMounted) return;
    
    try {
      const elPopup = document.querySelector('.fr-popup.fr-desktop.fr-active');
      if (elPopup) {
        elPopup.style.zIndex = '2147483647';
      }
    } catch (error) {
      console.warn('Erro ao recalcular posição do Froala:', error);
    }
  };

  componentWillUnmount() {
    this.bIsMounted = false;
    this.removeEventListeners();
    this.editorRef = null;
  }

  removeEventListeners = () => {
    try {
      if (typeof window !== 'undefined' && window.removeEventListener) {
        window.removeEventListener('scroll', this.recalculateFroalaPosition);
        window.removeEventListener('resize', this.recalculateFroalaPosition);
      }
    } catch (error) {
      console.warn('Erro ao remover event listeners:', error);
    }
  }

  getSelectedText = () => {
    try {
      if (this.editorRef && this.editorRef.getEditor) {
        const editorInstance = this.editorRef.getEditor();
        if (editorInstance && editorInstance.selection) {
          return editorInstance.selection.text();
        }
      }
      return '';
    } catch (error) {
      console.warn('Erro ao obter texto selecionado:', error);
      return '';
    }
  }

  callGptAPI = (cSelection) => {
    if (!this.bIsMounted) return;
    
    this.setState({ isLoading: true });

    Axios.patch("/customer/handle-gpt-request", {
      selection: cSelection
    }, {
      headers: {
        "Content-Type": "application/json",
        'Authorization': `Bearer ${localStorage.getItem('cStorageToken')}`,
      }
    })
    .then(response => {
      if (!this.bIsMounted) return;
      
      this.setState({ isLoading: false });
      const data = response.data;
      
      if (data.cResult && this.editorRef && this.editorRef.getEditor) {
        const editorInstance = this.editorRef.getEditor();
        if (editorInstance && editorInstance.html) {
          const responses = data.cResult.join('<br><br>');
          editorInstance.html.insert(cSelection + '<br>' + responses);
        }
      }
    })
    .catch(error => {
      if (!this.bIsMounted) return;
      
      console.error('Erro ao solicitar resposta do ChatGPT:', error);
      this.setState({ isLoading: false });

      if (this.editorRef && this.editorRef.getEditor) {
        const editorInstance = this.editorRef.getEditor();
        if (editorInstance && editorInstance.html) {
          if (error.response && error.response.data && error.response.data.cError) {
            const errorMessage = error.response.data.cError;
            const errorDetail = error.response.data.cDetails;
            editorInstance.html.insert(`<p><strong>Error:</strong> ${errorMessage}</p><br>`);
            if (errorDetail) editorInstance.html.insert(`<p> ${errorDetail}</p>`);
          } else {
            editorInstance.html.insert('<p><strong>Error:</strong> Falha na comunicação com o ChatGPT. Por favor, tente novamente mais tarde.</p>');
          }
        }
      }
    });
  }

  handleModelChange(cModel) {
    if (!this.bIsMounted) return;
    
    this.setState({
      model: cModel
    });
  }

  hideAlert = () => {
    if (!this.bIsMounted) return;
    
    this.setState({
      cErrorModalMsg: '',
      alertMessage: '',
    });
  };

  render() {
    const { fnHandleChange, bSimpleEditor, cTypeComment, bReadOnly } = this.props;
    const { alertMessage, model, isLoading, bHasGptKey, cErrorModalMsg } = this.state;
    
    this.config['toolbarSticky'] = true;
    this.config['toolbarStickyOffset'] = 20;
    this.config['heightMin'] = 300;
    this.config['heightMax'] = 800;
    this.config['language'] = ["pt_br"];
    this.config['fontSizeUnit'] = 'pt';
    this.config['attribution'] = false;
    this.config['documentReady'] = true;
    this.config['charCounterCount'] = false;
    this.config['videoAllowedAttributes'] = ['src', 'width', 'height', 'controls', 'poster', 'source', 'type', 'style', 'class', 'name', 'id'];
    this.config['videoAllowedTypes'] = ['mp4'];
    this.config['videoUploadMethod'] = 'POST';
    this.config['videoMaxSize'] = 80 * 1024 * 1024;
    
    // Eventos protegidos contra null/undefined
    this.config['events'] = {
      'initialized': function () {
        try {
          if (this && this.opts && this.toolbar) {
            this.opts.toolbarSticky = true;
            this.toolbar.show();
          }
        } catch (error) {
          console.warn('Erro no evento initialized:', error);
        }
      },
      'contentChanged': function () {
        try {
          setTimeout(() => {
            if (typeof window !== 'undefined' && window.dispatchEvent) {
              window.dispatchEvent(new Event('resize'));
            }
          }, 100);
        } catch (error) {
          console.warn('Erro no evento contentChanged:', error);
        }
      },
      'video.error': (evtVidErr) => {
        if (this.bIsMounted && evtVidErr && evtVidErr.code === 5) {
          this.setState({ cErrorModalMsg: intl.get('DocumentEditor.erro_upload_video_dimensoes') });
        }
      },
      'paste.beforeCleanup': function (clipboardHtml) {
        try {
          if (!clipboardHtml || typeof clipboardHtml !== 'string') return clipboardHtml;
          
          // Código de limpeza do clipboard mantido, mas com proteções
          clipboardHtml = clipboardHtml.replace(/<div[^>]*?style="[^"]*?height:\s*\d+\.?\d*px;?[^"]*?"[^>]*?>/g, function (match) {
            return match.replace(/height:\s*\d+\.?\d*px;?/g, '');
          });

          clipboardHtml = clipboardHtml.replace(/<\/?h[1-6][^>]*>/g, function (match) {
            return match.startsWith('</') ? '</p>' : '<p>';
          });

          clipboardHtml = clipboardHtml.replace(/:\s*[^;]*var\(--[^)]+\)[^;]*;/g, function (match) {
            return match.replace(/var\(--[^)]+\)/g, '').trim();
          });

          clipboardHtml = clipboardHtml.replace(/<[^>]*?style="[^"]*?white-space:\s*pre;?[^"]*?"[^>]*?>/g, function (match) {
            return match.replace(/white-space:\s*pre;?/g, '').trim();
          });

          return clipboardHtml;
        } catch (error) {
          console.warn('Erro no paste.beforeCleanup:', error);
          return clipboardHtml;
        }
      },
      'initialized': function() {
        try {
          if (bReadOnly && this && this.edit && typeof this.edit.off === 'function') {
            this.edit.off();
          }
        } catch (error) {
          console.warn('Erro ao configurar modo read-only:', error);
        }
      },
      'image.beforeRemove': function (img) {
        try {
          if (!img || typeof img.attr !== 'function') return;
          
          const imageUrl = img.attr('src');
          if (!imageUrl) return;

          const cPath = imageUrl.replace(`${url.cBase}`, '');
          Axios.delete(cPath).catch(err => console.warn('Erro ao deletar imagem:', err));
        } catch (error) {
          console.warn('Erro no image.beforeRemove:', error);
        }
      },
      'video.beforeRemove': function (video) {
        try {
          if (!video || !video[0] || !video[0].firstChild) return;
          
          const videoElement = video[0].firstChild;
          const videoUrl = videoElement ? videoElement.currentSrc : null;
          if (!videoUrl) return;

          const cPath = videoUrl.replace(`${url.cBase}`, '');
          Axios.delete(cPath).catch(err => console.warn('Erro ao deletar vídeo:', err));
        } catch (error) {
          console.warn('Erro no video.beforeRemove:', error);
        }
      }
    };

    this.config['key'] = process.env.REACT_APP_FROALA_LICENSE_KEY;
    
    if (bReadOnly) {
      this.config['listAdvancedTypes'] = false;
      this.config['toolbarButtons'] = [];
    } else if (bSimpleEditor) {
      this.config['listAdvancedTypes'] = false;
      this.config['toolbarBottom'] = true;
      this.config['height'] = 200;
      if (cTypeComment === 'X') {
        this.config['toolbarButtons'] = {
          "moreMisc": {
            "buttons": [
              'fullscreen', 'bold', 'italic', 'underline'
            ],
            'align': 'left',
            'buttonsVisible': 4
          },
          'moreText': {
            'buttons': [
              'chatGPT', 'formatOL', 'formatUL', 'fontFamily', 'paragraphFormat', 'alignLeft', 'alignCenter', 'alignRight', 'alignJustify', "quote"
            ],
            'buttonsVisible': 3
          }
        };
      } else {
        this.config['toolbarButtons'] = {
          "moreMisc": {
            "buttons": [
              'chatGPT', 'fullscreen', 'bold', 'italic', 'underline', 'insertLink', 'insertImage', 'insertVideo'
            ],
            'align': 'left',
            'buttonsVisible': 4
          },
          'moreText': {
            'buttons': [
              'formatOL', 'formatUL', 'fontFamily', 'paragraphFormat', 'alignLeft', 'alignCenter', 'alignRight', 'alignJustify', "quote"
            ],
            'buttonsVisible': 4
          }
        };
      }
    } else {
      this.config['listAdvancedTypes'] = true;
    }

    return (
      <div>
        <FroalaEditor
          ref={elRef => {
            this.editorRef = elRef;
          }}
          model={model}
          onModelChange={evt => {
            if (this.bIsMounted) {
              this.handleModelChange(evt);
              if (typeof fnHandleChange === 'function') {
                fnHandleChange(evt);
              }
            }
          }}
          config={this.config}
          typingTimer={1000}
        />
        {cErrorModalMsg && (
          <SweetAlert
            error
            title=""
            onCancel={this.hideAlert}
            onConfirm={this.hideAlert}
            closeOnClickOutside
            allowEscape
            showConfirm
          >
            {cErrorModalMsg}
          </SweetAlert>
        )}
        {(!cErrorModalMsg && alertMessage) && (
          <GptModal
            bHasGptKey={bHasGptKey}
            fnOnClose={this.hideAlert}
            fnOnSave={this.saveApiKey}
            cMessage={alertMessage}
          />
        )}
        {isLoading && (
          <div style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 9999
          }}>
            <img src={fLoading} alt="Carregando..." />
          </div>
        )}
      </div>
    );
  }
}

FroalaEditorComponent.defaultProps = {
  config: {
    useClasses: true,
    attribution: false
  },
  model: null,
  elEditor: null,
  fnRef: null,
  bReadOnly: false,
};


class GptModal extends Component {
  constructor(oProps) {
    super(oProps);
    this.state = {
      cApiKey: '',
      bHasApiKey: oProps.bHasApiKey,
      bIsSending: false,
      cAlertMsg: '',
    }
    this.hideAlert = this.hideAlert.bind(this);
    this.onClose = this.onClose.bind(this);
    this.onSave = this.onSave.bind(this);
    this.handleApiKeyChange = this.handleApiKeyChange.bind(this);
  }

  hideAlert = () => {
    this.setState({ cAlertMsg: '' });
  }

  onClose = () => {
    const { fnOnClose } = this.props;
    fnOnClose();
  }

  handleApiKeyChange = (evtChange) => {
    this.setState({ cApiKey: evtChange.target.value });
  }

  onSave = async () => {
    const { cApiKey, bIsSending } = this.state;
    const { fnOnSave } = this.props;

    if (bIsSending) return;
    this.setState({ bIsSending: true });

    try {
      await Axios.patch("/customer/update-api-key", {
        cust_ckeyapigpt: JSON.stringify({ cApiKey })
      }, {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('cStorageToken')}`,
        },
      });
      localStorage.setItem('cApiGpt', 1);
      this.setState({
        cAlertMsg: '',
        bHasApiKey: localStorage.getItem('cApiGpt') === '1',
      });
      fnOnSave(cApiKey);
      this.onClose();
      //  console.log("Configurações da API GPT salvas com sucesso!");
    } catch (oError) {
      //  console.error("Erro ao salvar as configurações da API GPT:", error);
      const cAlertMsg = oError.response?.data?.cError ??
        "Erro desconhecido ao salvar a chave da API";
      this.setState({
        cApiKey: '',
        bHasApiKey: localStorage.getItem('cApiGpt') == '1',
        cAlertMsg,
        bIsSending: false,
      });
    }
  }

  render() {
    // listados todos os props que aceita aqui para saber quais são
    const { cMessage, /* bHasApiKey, fnOnSave, fnOnClose */ } = this.props;
    const { cAlertMsg, bIsSending, cApiKey } = this.state;

    return (
      <SweetAlert
        customClass="modal-edit md ScrollBar"
        title=""
        onCancel={this.onClose}
        onConfirm={this.onClose}
        showConfirm={false}
        closeOnClickOutside
        allowEscape
      >
        <div className="head-modal" style={{ marginTop: '-38px' }}>
          {intl.get('ChatGpt.titulo_api')}
          <span
            role="button"
            tabIndex="0"
            aria-labelledby="head-modal"
            onKeyPress={this.onClose}
            onClick={this.onClose}
            className="close"
            href=""
          />
        </div>
        {cAlertMsg && (
          <Alert type="error" message={cAlertMsg} onCloseAlert={this.hideAlert}>
            {cAlertMsg}
          </Alert>
        )}
        {cMessage}
        <div>
          <br />
          <input
            type="text"
            className="form form-control"
            style={{
              display: 'block',
              width: '100%',
              height: '40px',
              padding: '0 15px',
              border: '1px solid #ccc',
              borderRadius: '3px',
              marginTop: '5px',
              backgroundColor: '#fff',
              fontSize: '16px',
              fontFamily: '"Source Sans Pro", Helvetica, Arial, sans-serif',
              color: '#777',
              backgroundColor: '#fff',
              transition: 'all 200ms'
            }}
            onChange={this.handleApiKeyChange}
            value={cApiKey}
            placeholder="Digite a chave da API"
          />
          <br />
        </div>
        <div>
          <Button variant="success" href="https://platform.openai.com/api-keys" target='_blank'>{intl.get('ChatGpt.obter_chave')}</Button>
          <Button variant="info" href="https://openai.com/pricing" target='_blank'>{intl.get('ChatGpt.ver_planos')}</Button>
          <Button variant="primary" disabled={bIsSending} onClick={this.onSave}>{intl.get('ChatGpt.salvar_api')}</Button>
        </div>
      </SweetAlert>
    );
  }
}
